module.exports = __webpack_public_path__ + "img/success.db99217d.gif";